'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');
var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var UrlDiscoveryApi = function (_BaseApi) {
  (0, _inherits3.default)(UrlDiscoveryApi, _BaseApi);
  function UrlDiscoveryApi() {
    (0, _classCallCheck3.default)(this, UrlDiscoveryApi);
    return (0, _possibleConstructorReturn3.default)(this, (UrlDiscoveryApi.__proto__ || Object.getPrototypeOf(UrlDiscoveryApi)).call(this, '' + _frontendUtils.endpoints.apiBaseUrl));
  }

  /**
   * Gets URL groups associated with a domain.
   * @param  {String} domainName  Domain to find url groups for
   * @return {Promise}            Resolves, if successful, to an array of domain group objects. Otherwise returns an error.
   */

  (0, _createClass3.default)(UrlDiscoveryApi, [{
    key: 'getDomainGroups',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(domainName) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (ValidationUtils.isString(domainName)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt('return', Promise.reject(new _ParameterError2.default('domainName', domainName, 'string.')));
              case 2:
                return _context.abrupt('return', this.makeRequest({
                  method: 'GET',
                  url: 'domain/' + domainName + '/group'
                }));
              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getDomainGroups(_x) {
        return _ref.apply(this, arguments);
      }
      return getDomainGroups;
    }()

    /**
     * Gets domain details.
     * @param  {String} domainName  Domain to find details for
     * @return {Promise}            Resolves, if successful, to a domain object. Otherwise returns an error.
     */
  }, {
    key: 'getDomainDetails',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(domainName) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (ValidationUtils.isString(domainName)) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt('return', Promise.reject(new _ParameterError2.default('domainName', domainName, 'string.')));
              case 2:
                return _context2.abrupt('return', this.makeRequest({
                  method: 'GET',
                  url: 'domain/' + domainName
                }));
              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getDomainDetails(_x2) {
        return _ref2.apply(this, arguments);
      }
      return getDomainDetails;
    }()

    /**
     * Fetch the sitemap for a given domain.
     * @param  {String} domainName  Domain to fetch sitemap for
     * @param  {String} force       Boolean to force refresh if we already have a sitemap for the domain. Only Admin and Support users can set the force flag.  
     * @return {Promise}            Resolves, if successful, to a domain object. Otherwise returns an error.
     */
  }, {
    key: 'fetchSitemap',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(domainName) {
        var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (ValidationUtils.isString(domainName)) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt('return', Promise.reject(new _ParameterError2.default('domainName', domainName, 'string.')));
              case 2:
                return _context3.abrupt('return', this.makeRequest({
                  method: 'POST',
                  url: 'domain',
                  body: {
                    domainName: domainName,
                    force: force
                  }
                }));
              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function fetchSitemap(_x3) {
        return _ref3.apply(this, arguments);
      }
      return fetchSitemap;
    }()
  }]);
  return UrlDiscoveryApi;
}(_BaseApi3.default);
exports.default = UrlDiscoveryApi;